import { Component, OnInit } from '@angular/core';
import { DetalleVentaService } from 'src/app/service/index.service';
import * as moment from 'moment';
import { Categoria } from 'src/app/model/index.model';

@Component({
  selector: 'app-reporte-categoria',
  templateUrl: './reporte-categoria.component.html',
  styleUrls: ['./reporte-categoria.component.css']
})
export class ReporteCategoriaComponent implements OnInit {
  fechade: any;
  fechaha: any;
  search: String = "";
  items: any;
  ganancia: any;

  fecha = new Date();
  constructor(private wsdl: DetalleVentaService) { }

  ngOnInit() {
  }

  parseDate(fecha) {
    if (moment(fecha).isValid()) {
      return moment(fecha);
    }
  }

  async getList() {
    try {

      this.fechade = moment(this.fechade).format("YYYY-MM-DD") + " 00:00:00";
      this.fechaha = moment(this.fechaha).format("YYYY-MM-DD") + " 23:59:00";

      let data = await this.wsdl.getVentasByCategoria(this.fechade, this.fechaha, this.search).then();
      console.log(data)
      let res = JSON.parse(JSON.stringify(data));
      if (res.code == 200) {
        this.items = res.data;
        this.ganancia = res.ganancia;
      }
    } catch (error) {

    }
  }

  descargarExcel() {
    this.exportTableToExcel('tblData', 'reporte-categoria-' + new Date().toISOString().split('T')[0]);
  }

  // para exportar a excel
  /**
 * Exporta una tabla HTML a archivo Excel (.xlsx)
 * @param tableID ID del elemento <table> que querés exportar
 * @param filename Nombre del archivo (sin extensión)
 */
  exportTableToExcel(tableID: string, filename: string = 'datos_exportados'): void {
    const table = document.getElementById(tableID);
    if (!table) {
      console.error(`No se encontró la tabla con ID: ${tableID}`);
      return;
    }

    // Limpiamos un poco el HTML (opcional pero recomendado)
    const tableHTML = table.outerHTML
      .replace(/ /g, '%20')           // espacios → %20 para URL
      .replace(/<a[^>]*>|<\/a>/g, ''); // quitamos links si hay (evita problemas)

    // Creamos el Blob con MIME tipo Excel
    const blob = new Blob(['\ufeff', tableHTML], {
      type: 'application/vnd.ms-excel;charset=utf-8;'
    });

    // Creamos URL temporal
    const url = window.URL.createObjectURL(blob);

    // Creamos link invisible para descargar
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `${filename}.xls`;  // .xls es más compatible que .xlsx para HTML simple

    // Agregamos al DOM, clickeamos y limpiamos
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Limpieza (importante para evitar memory leaks)
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  }
  itemSel(event: Categoria) {
    if (event.id !== undefined) {
      this.search = event.nombre;
    }

  }
}
